export function mapProducts(products = []) {
  return products
    .map((product) =>
      product
        ? {
            ProductName: product.name,
            ImgSrc: product.image,
            ImgAlt: product.name,
            ProductWeight: product.size,
            NutritionName: product.nutrition_fact_per,
            NutritionItems:
              product.nutrition_fact_info?.map((item) => ({
                ItemName: item.title,
                ItemDes: item.quantity,
              })) || [],
          }
        : null
    )
    .filter(Boolean);
}
